import { render, staticRenderFns } from "./liangbiao-content-transfer.vue?vue&type=template&id=669ec980&"
import script from "./liangbiao-content-transfer.vue?vue&type=script&lang=ts&"
export * from "./liangbiao-content-transfer.vue?vue&type=script&lang=ts&"
import style0 from "./liangbiao-content-transfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports